import { useMemo } from 'react';
import { PaymentProviders } from 'shared-types';
import type { PaymentProvider } from 'shared-types/Order';

type PaymentProviderInfo = {
  provider: PaymentProvider;
  isStripe: boolean;
  isDatatrans: boolean;
  isMock: boolean;
};

type PaymentProviderSource = { paymentProvider?: PaymentProvider | null } | null | undefined;

export const usePaymentProvider = (source: PaymentProviderSource): PaymentProviderInfo => {
  return useMemo(() => {
    const provider = source?.paymentProvider ?? PaymentProviders.STRIPE;
    const providerLower = provider.toLowerCase();

    return {
      provider,
      isStripe:
        providerLower === PaymentProviders.STRIPE.toLowerCase() ||
        providerLower === PaymentProviders.STRIPE_LEGACY.toLowerCase(),
      isDatatrans: providerLower === PaymentProviders.DATATRANS.toLowerCase(),
      isMock: providerLower === PaymentProviders.MOCK.toLowerCase(),
    };
  }, [source]);
};
